import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AppConfigService {

  private config: any;

  constructor(private http: HttpClient) {}

  async loadConfig(): Promise<void> {
    try {
      const data = await firstValueFrom(
        this.http.get('assets/configuration/configuration.json')
      );
      this.config = data;
    } catch (error) {
      console.error('Failed to load config:', error);
      this.config = {};
    }
  }

  get setting() {
    return this.config;
  }
}
